import { Grid2 as Grid, Typography } from "@mui/material";
import { FC } from "react";
import { Breakable } from "src/shared/components/Breakable";
import LabeledValue from "src/shared/components/LabeledValue";
import { ECountries } from "src/shared/types/common.types";
import { IBankAccount } from "src/shared/types/partnerBankAccount";

interface IBankAccountProps {
  bank_account?: IBankAccount;
  country_id: ECountries;
  is_resident: boolean;
}
export const BankAccount: FC<IBankAccountProps> = ({
  bank_account,
  country_id,
  is_resident,
}) => {
  const isResidentBy = country_id === ECountries.BY && is_resident;
  const isOther = !is_resident;

  return (
    <Grid container spacing={4}>
      <Grid size={12}>
        <Typography sx={{ color: "grey.500" }}>Банковские реквизиты</Typography>
      </Grid>

      <LabeledValue
        label={isResidentBy ? "Расчетный счет/IBAN" : "Расчетный счет"}
        value={<Breakable>{bank_account?.current_account}</Breakable>}
      />

      {bank_account?.transit_account && (
        <LabeledValue
          label="Транзитный счет"
          value={<Breakable>{bank_account.transit_account}</Breakable>}
        />
      )}

      {!isResidentBy && (
        <LabeledValue
          label="Корреспондентский счет"
          value={<Breakable>{bank_account?.correspondent_account}</Breakable>}
        />
      )}

      <LabeledValue
        label={isOther ? "БИК (SWIFT)" : "БИК"}
        value={<Breakable>{bank_account?.bank?.bic}</Breakable>}
      />

      <LabeledValue
        label={isOther ? "Наименование банка / Bank name" : "Наименование"}
        value={<Breakable>{bank_account?.bank?.name}</Breakable>}
      />

      <LabeledValue
        label={isOther ? "Адрес / Bank address" : "Адрес"}
        value={<Breakable>{bank_account?.bank?.address}</Breakable>}
      />

      {isOther && (
        <>
          <LabeledValue
            label="БИК (SWIFT) банка-корреспондента:"
            value={
              <Breakable>{bank_account?.correspondent_bank?.bic}</Breakable>
            }
          />
          <LabeledValue
            label="Наименование банка-корреспондента:"
            value={
              <Breakable>{bank_account?.correspondent_bank?.name}</Breakable>
            }
          />
        </>
      )}
    </Grid>
  );
};
